export default "__VITE_ASSET__bd67399a__"